<div class="drawer-content">
    <ng-container *ngIf="isLoading">
      <div class="loading-container">
        <nz-spin nzTip="Loading..."></nz-spin>
      </div>
    </ng-container>
  
    <ng-container *ngIf="error">
      <nz-alert nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>
    </ng-container>
  
    <ng-container *ngIf="!isLoading && !error && postDetails">
      <div class="post-details-section">
       <br />       
        <nz-descriptions nzBordered [nzColumn]="1" nzSize="small">
          <nz-descriptions-item nzTitle="Posted by">{{ postDetails.politician.name }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Posted on">{{ formatDatetime(postDetails.time) }}</nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Post Content">
            <div class="post-text">{{ postDetails.postText }}</div>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Post URL">
            <a [href]="postDetails.postUrl" target="_blank">
              {{ postDetails.postUrl }} &nbsp;
              <fa-icon [icon]="faExternalLink"></fa-icon>
            </a>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Engagement">
            <nz-tag [nzColor]="'blue'"  nz-tooltip nzTooltipTitle="Likes">
              <i nz-icon nzType="like" nzTheme="outline"></i> {{ postDetails.reactionsLike }}
            </nz-tag>
            <nz-tag [nzColor]="'red'"  nz-tooltip nzTooltipTitle="Love reactions">
              <i nz-icon nzType="heart" nzTheme="outline"></i> {{ postDetails.reactionsLove }}
            </nz-tag>
            <nz-tag [nzColor]="'orange'" nz-tooltip nzTooltipTitle="Haha reactions">
              <i nz-icon nzType="smile" nzTheme="outline"></i> {{ postDetails.reactionsHaha }}
            </nz-tag>
            <nz-tag [nzColor]="'cyan'" nz-tooltip nzTooltipTitle="Wow reactions">
              <i nz-icon nzType="carry-out" nzTheme="outline"></i> {{ postDetails.reactionsCare }}
            </nz-tag>
            <nz-tag [nzColor]="'volcano'" nz-tooltip nzTooltipTitle="Sad reactions">
              <i nz-icon nzType="fire" nzTheme="outline"></i> {{ postDetails.reactionsAngry }}
            </nz-tag>
            <nz-tag [nzColor]="'green'" nz-tooltip nzTooltipTitle="Shares count">
              <i nz-icon nzType="share-alt" nzTheme="outline"></i> {{ postDetails.shares }}
            </nz-tag>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Type" *ngIf="postDetails?.type">{{ postDetails.type?.type }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Topic" *ngIf="postDetails?.topic">{{ postDetails.topic?.name }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Attacked Politician" *ngIf="postDetails.attackedPolitician">{{ postDetails.attackedPolitician }}</nz-descriptions-item>
        </nz-descriptions>
      </div>
    </ng-container>

    <ng-container *ngIf="postDetails?.id != null">
      <app-facebook-comments [postId]="postDetails?.id"></app-facebook-comments>
    </ng-container>

    <div class="drawer-footer">
      <button nz-button nzType="primary" (click)="close()">Close</button>
    </div>
  </div>